export const SESSION_RESTORING_ATTRIBUTE = 'data-session-restoring';

const SESSION_COOKIE_PATTERN = /(?:^|; )jwtToken=[^;=]*[^;=\s]/;

export function hasSessionToken(cookie: string): boolean {
  return SESSION_COOKIE_PATTERN.test(cookie);
}

export const MARK_SESSION_RESTORING_SCRIPT = `if(${SESSION_COOKIE_PATTERN}.test(document.cookie))document.documentElement.setAttribute('${SESSION_RESTORING_ATTRIBUTE}','');`;

const WHILE_SESSION_RESTORING = `html[${SESSION_RESTORING_ATTRIBUTE}] &`;

export const HIDE_WHILE_SESSION_RESTORING = {
  [WHILE_SESSION_RESTORING]: { display: 'none' },
};

export const INVISIBLE_WHILE_SESSION_RESTORING = {
  [WHILE_SESSION_RESTORING]: { visibility: 'hidden' },
};

export function clearSessionRestoringMark() {
  document.documentElement.removeAttribute(SESSION_RESTORING_ATTRIBUTE);
}
